import { defineMessages } from 'react-intl'

const scope = `procurify.purchasing.pages`

export default defineMessages({
  orderDetailsPageTitle: {
    id: `${scope}.orderDetailsPageTitle`,
    defaultMessage: 'Order Details',
  },
  createOrderRequestPageTitle: {
    id: `${scope}.createOrderRequestPageTitle`,
    defaultMessage: 'Create order request',
  },
  orderApprovalsPageTitle: {
    id: `${scope}.orderApprovalsPageTitle`,
    defaultMessage: 'Order approvals',
  },
})
